import "./drawer.scss";
import { PageState, PageComponent } from "barba";
import scrollToNode from "utils/scroll-to-node";

class Drawer {
    constructor({ node }) {
        this.drawer = node;
        this.id = this.drawer.id || null;
        this.head = this.drawer.querySelector("[data-drawer-head]");
        this.body = this.drawer.querySelector("[data-drawer-body]");
        this.subdrawers = this.drawer.querySelectorAll("[data-drawer]");
        this.isOpen = false;
        this.scrollInView = this.drawer.hasAttribute("data-drawer-scroll-in-view");

        this.toggleHandler = this.toggle.bind(this);
        this.updateMaxHeightHandler = this.updateMaxHeight.bind(this);

        if (this.head) {
            this.head.addEventListener("click", this.toggleHandler);
        }
        window.addEventListener("resize", this.updateMaxHeightHandler);

        if (this.id && PageState.get(this.id)) {
            this.open();
        } else {
            this.close();
        }

        if (this.subdrawers) {
            this.subdrawers.forEach((x) => {
                const subHead = x.querySelector("[data-drawer-head]");
                if (subHead) {
                    subHead.addEventListener("click", this.updateMaxHeightHandler);
                }
            });
        }

        this.drawer.style.setProperty("--drawer-body-height", "auto");
    }

    open() {
        this.isOpen = true;
        this.updateMaxHeight();

        if (this.scrollInView) {
            window.requestAnimationFrame(() => scrollToNode(this.drawer));
        }
    }

    close() {
        this.isOpen = false;
        this.updateMaxHeight();
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
        this.updatePageState();
    }

    updateMaxHeight() {
        if (this.isOpen) {
            const ticks = [0, 50, 100, 300];

            for (let i = 0; i < ticks.length; i++) {
                window.setTimeout(() => {
                    window.requestAnimationFrame(
                        () =>
                            !this.drawer ||
                            this.drawer.style.setProperty("--drawer-body-max-height", `${this.body.scrollHeight}px`)
                    );
                }, ticks[i]);
            }

            this.drawer.classList.add("is-open");
            return;
        }
        this.drawer.style.setProperty("--drawer-body-max-height", "0");
        this.drawer.classList.remove("is-open");
    }

    updatePageState() {
        if (this.id) {
            PageState.set(this.id, this.isOpen);
        }
    }

    destroy() {
        this.head.removeEventListener("click", this.toggleHandler);
        window.removeEventListener("resize", this.updateMaxHeightHandler);

        delete this.toggleHandler;
        delete this.updateMaxHeightHandler;

        delete this.subdrawers;
        delete this.drawer;
        delete this.head;
        delete this.body;
        delete this.isOpen;
        delete this.scrollInView;
    }
}

new PageComponent("[data-drawer]", Drawer);
